import { render } from "./create-video-modal.vue?vue&type=template&id=02f6981c"
import script from "./create-video-modal.vue?vue&type=script&lang=js"
export * from "./create-video-modal.vue?vue&type=script&lang=js"
script.render = render

export default script